export default class Video {

    // Constructor
    constructor() {
        this.playButton = null;
    }

    // Init before frameworks
    init() {
        this.playButton = document.querySelector('.tps-detail-header-media-video-wrapper');

		if (this.playButton) {
			this.setEvent_playOnClick();
		}
    }

    // Init after frameworks
    initAfterFrameworks() { }

    // Destroy
    destroy() {
		if (this.playButton) {
			this.playButton.removeEventListener('click', this._playOnClick, true);
		}
    }

    // Set event: play YT video on play click
    setEvent_playOnClick() {
        this.playButton.addEventListener('click', this._playOnClick, true);
    }

    // Helper: play YT video on play click
    _playOnClick() {
		const self = window.tps.video; // this;

		const playButton = self.playButton;
		const image = playButton.querySelector('.tps-detail-header-media-img');
		const video = playButton.querySelector('.tps-detail-header-media-video');

		const url = self.playButton.dataset.embedUrl;
		const html = `<div class="responsive-embed widescreen"><iframe src="${url}?rel=0&showinfo=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;

		playButton.classList.add('playing');
		image.classList.add('hide');

		video.innerHTML = html;
		video.classList.remove('hide');
	}

}
